<template>
    <div class="modal-card card">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">Map My Data - Input</h4>
            <!-- Close -->
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="card-body">
            <div v-if="fileType == 'csv' || fileType == 'json'">
                <div class="mb-2">
                    <span>InputFile.{{ fileType }}</span>
                </div>
                <CodemirrorEditor :editorId="`${fileType}-${Math.random()}`" v-model="content" :mode="fileType" :refreshOn="true"
                :disabled="true" :readOnly="true" :performLint="false"></CodemirrorEditor>
            </div>
            <div v-else>
                <div v-if="fileDetails">
                    <OutputParser :compData="fileDetails"/>
                </div>
                <div v-else>
                    <ul class="list-group list-group-sm bg-warning">
                        <li class="list-group-item">
                            <i class="fa-solid fa-circle-exclamation"></i>
                            No preview available
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="card-footer text-end">
            <button class="btn btn-primary" :disabled="downloading" @click="handleDownload">
                <div v-if="downloading" class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else>
                    Download
                </div>
            </button>
        </div>
    </div>
</template>

<script>
import CodemirrorEditor from "../../components/CodemirrorEditor.vue";
import OutputParser from "../OutputParser.vue";
export default {
    components: { CodemirrorEditor, OutputParser },
    data() {
        return {
            content: null,
            fileType: "",
            downloading: false,
            copied: false,
        }
    },
    props: {
        modalData: {
            type: [Object, Array, String],
        },
    },
    computed: {
        fileDetails() {
            if (!this.content || !this.fileType) return null;
            return {
                filecontent: this.content,
                filetype: this.fileType,
                filename: `InputFile.${this.fileType}`
            }
        }
    },
    beforeMount() {
        this.content = JSON.parse(JSON.stringify(this.modalData.content)) // deep clone
        this.fileType = JSON.parse(JSON.stringify(this.modalData.file_type)) // deep clone
    },
    methods: {
        handleDownload() {
            if (!this.content || !this.content.length) {
                this.error = "Input File not found"
                return;
            }
            this.downloading = true;
            let toastOptions;
            try {
                let file_content = this.fileType == "avro" || this.fileType == "parquet" ? [this.decodeFileContent(this.content)]  : [this.content]

                // Create a Blob from the File content
                const blob = new Blob(file_content, { type: this.fileType == "avro" ? "application/octet-stream" : "text/csv;charset=utf-8;" });
                const url = URL.createObjectURL(blob);

                // Create a temporary link and trigger download
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", `InputFile.${this.fileType}`); // specify the file name
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (error) {
                console.error("Download failed:", error);
                toastOptions = {
                    message: "Failed to download file.",
                    type: "error",
                };
                this.$store.dispatch("addToast", toastOptions);
            } finally {
                this.downloading = false;
            }
        },
        decodeFileContent(content) {
            let encodedAvro = JSON.parse(JSON.stringify(content)) // deep clone

            const binaryStr = atob(encodedAvro)
            const bytes = new Uint8Array(binaryStr.length)
            for (let i = 0; i < binaryStr.length; i++) {
                bytes[i] = binaryStr.charCodeAt(i)
            }
            return bytes
        }
    }
}
</script>

<style scoped></style>